<template>
  <div>
    <div class="setting-wrap">
      <div class="wrap-title">
        ブランド
        <el-tooltip>
          <div slot="content">ブランドを追加することで、ブランド別のリスト管理が行えるようになります</div>
          <font-awesome-icon :icon="['fas', 'question-circle']" />
        </el-tooltip>
      </div>
      <div class="setting-subwrap top">
        <div class="setting-member-wrap">
          <div class="setting-member-user pointer" v-for="(target_client, index) in target_client" v-bind:key="target_client.id">
            <div class="setting-member-image">
              <el-tooltip content="写真を変更" placement="top">
                <div class="setting-member-icon" @click="openImgChangeDrawer(target_client.target_client_id, index)">
                  <font-awesome-icon :icon="['fas', 'camera-alt']" />
                </div>
              </el-tooltip>
              <el-image :src="target_client.img_url" class="setting-member-profile">
                <div slot="error" class="setting-member-noimg">{{ target_client.target_client_name | firstLetter }}</div>
              </el-image>
            </div>
            <div class="setting-member-name">
              <span class="pointer">{{ target_client.target_client_name }}</span>
            </div>
            <div class="setting-member-edit">
              <el-tooltip>
                <div slot="content">ブランド名を編集</div>
                <i class="el-icon-edit" @click="changeBrandName(target_client.target_client_name, target_client.target_client_id, 'client')"></i>
              </el-tooltip>
              <el-tooltip>
                <div slot="content">ブランドを削除</div>
                <i class="el-icon-delete" @click="deleteBrand(target_client.target_client_name, target_client.target_client_id, 'client')"></i>
              </el-tooltip>
            </div>
          </div>
          <div class="setting-member-add" @click="createBrand('client')">
            <font-awesome-icon icon="plus" />
            <div class="setting-member-add-description">ブランドを追加</div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog title="イメージ画像の変更" :visible.sync="img_change" width="420px" top="20vh">
      <el-upload drag :on-change="imgAdd" :auto-upload="false" list-type="picture" :limit="1" :file-list="fileList" action="">
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          画像をドロップ
          <em>もしくは選択してアップロードしてください</em>
        </div>
        <div class="el-upload__tip" slot="tip">推奨ファイル:500kb以下のjpg/png形式</div>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button @click="(img_change = false), (fileList = [])">キャンセル</el-button>
        <el-button type="primary" @click="memberImgUpload()" :disabled="file == ''">
          <div class="flex-row">
            変更
            <div class="loader--mini" v-show="loading"></div>
          </div>
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { handleApiResponse, ERROR_MESSAGES } from "@/components/common/responseHelper";
import { getImageUploadWarning } from "@/components/common/imageUploadHelper";
const root = process.env.VUE_APP_API;
const createBrandAPI = root + "/api/member/create_brand";
const changeBrandNameAPI = root + "/api/member/change_brand";
const loadMemberAPI = root + "/api/member/load_member";
const ImgUploadAPI = root + "/api/auth/img_upload";
const deleteBrandAPI = root + "/api/member/delete_brand";

export default {
  name: "Brand",
  components: {},
  props: [],
  data() {
    return {
      target_client: [],
      member: [],
      img_change: false,
      target_client_index: "",
      target_client_id: "",
      file: "",
      fileList: [],
      loading: false,
      person_id: 0,
      member_modal: false,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  mounted() {
    this.loadMember();
  },
  methods: {
    loadMember() {
      this.axios
        .get(loadMemberAPI, {
          params: {
            token: this.token,
          },
        })
        .then((response) => {
          if (handleApiResponse(response)) {
            console.error(ERROR_MESSAGES.DATA_FETCH_ERROR);
            return;
          }
          this.target_client = response.data.target_client;
        });
    },
    createBrand() {
      var target = "ブランド";
      this.$prompt(target + "の名前を入力してください", target + "を追加", {
        confirmButtonText: "追加",
        cancelButtonText: "キャンセル",
        inputPattern: /./,
        inputErrorMessage: target + "の名前を入力してください",
      }).then(({ value }) => {
        var params = new URLSearchParams();
        params.append("brand_name", value);
        params.append("token", this.token);
        this.axios.post(createBrandAPI, params).then(() => {
          this.loadMember();
          this.$message({
            type: "success",
            offset: 7,
            showClose: true,
            message: "「" + value + "」を追加しました",
          });
        });
      });
    },
    openImgChangeDrawer(target_client_id, target_client_index) {
      this.img_change = true;
      this.target_client_id = target_client_id;
      this.target_client_index = target_client_index;
    },
    imgAdd(file, fileList) {
      const result = getImageUploadWarning(file);
      if (result.message) {
        this.$message({
          type: result.allowUpload ? "warning" : "error",
          offset: 7,
          showClose: true,
          message: result.message,
        });
      }
      if (!result.allowUpload) {
        this.file = "";
        this.fileList = [];
        return;
      }
      this.file = file;
      this.fileList = fileList;
    },
    memberImgUpload() {
      if (!this.file || !this.file.raw) {
        return;
      }
      this.loading = true;
      var person_id = this.target_client_id;
      var formData = new FormData();
      formData.append("file", this.file.raw);
      var config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      formData.append("type", "client");
      formData.append("person_id", person_id);
      formData.append("token", this.token);
      this.axios
        .post(ImgUploadAPI, formData, config)
        .then((response) => {
          if (handleApiResponse(response)) {
            this.$message({
              message: ERROR_MESSAGES.IMAGE_UPLOAD,
              type: "error",
            });
            return;
          }
          this.target_client[this.target_client_index].img_url = response.data.img_url;
          this.file = "";
          this.fileList = [];
          this.img_change = false;
          this.$message({
            type: "success",
            offset: 7,
            showClose: true,
            message: "イメージを変更しました",
          });
        })
        .catch(() => {
          this.$message({
            message: ERROR_MESSAGES.IMAGE_UPLOAD,
            type: "error",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changeBrandName(name, id) {
      this.$prompt("新しいブランドの名前を入力してください", "「" + name + "」の名前変更", {
        confirmButtonText: "変更",
        cancelButtonText: "キャンセル",
        inputPattern: /./,
        inputValue: name,
        inputErrorMessage: "ブランドの名前を入力してください",
      }).then(({ value }) => {
        var params = new URLSearchParams();
        params.append("brand_name", value);
        params.append("brand_id", id);
        params.append("token", this.token);
        this.axios.post(changeBrandNameAPI, params).then(() => {
          this.loadMember();
          this.$message({
            type: "success",
            offset: 7,
            showClose: true,
            message: "「" + value + "」に変更しました",
          });
        });
      });
    },
    deleteBrand(name, id) {
      var target = "ブランド";
      const h = this.$createElement;
      this.$msgbox({
        title: target + "削除",
        type: "warning",
        message: h("p", null, [h("span", null, "「" + name + "」を削除しますか？"), h("br", null, ""), h("span", null, "この操作は取り消せません")]),
        showCancelButton: true,
        confirmButtonClass: "danger",
        confirmButtonText: "削除",
        cancelButtonText: "キャンセル",
      }).then(() => {
        var params = new URLSearchParams();
        params.append("brand_id", id);
        params.append("token", this.token);
        this.axios.post(deleteBrandAPI, params).then(() => {
          this.loadMember();
          this.$message({
            type: "success",
            offset: 7,
            showClose: true,
            message: "「" + name + "」を削除しました",
          });
        });
      });
    },
  },
  watch: {},
  filters: {
    firstLetter(val) {
      return val.slice(0, 1);
    },
  },
};
</script>
